// extracted by mini-css-extract-plugin
export default {"nav":"uvVI_HBcFuyUf_i8owh_"};